// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2083":"d583b84cefbdab71","6671":"69935b32fe84f24b","7008":"8d6d7466d8db3155"}[chunkId] + ".css";
};